import router from './router'
import constantRouterMap from './router/index.js'
import utils from './utils/utils.js'
import {setCookie} from "./utils/cookieUtil"; //引入全局变量
import {getCookie} from './utils/cookieUtil.js';//获取Cookie
import Main from './components/Main'
import api from './api'// 导入api接口
import axios from 'axios';

const _import = require('./router/_import_' + process.env.NODE_ENV)//获取组件的方法


var getRouter //用来获取后台拿到的路由

router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    //通过url设置cookie
    let userName = to.query.userName
    let auth = to.query.auth
    let companyId = to.query.companyId
    if (userName && auth && companyId && userName != '' && auth != '') {
      setCookie(global.cookieName, userName)
      setCookie('Authorization', auth)
      setCookie(global.companyId, companyId)
    }
    if (!getCookie(global.cookieName) && !getCookie("Authorization") && !getCookie(global.companyId)) { // 通过获取当前的Cookie判断是否登陆
      // next({
      //   path: '/login',
      //   query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      // })
      window.location.href = `${process.env.SSO_PORTAL}/cmc/#/login`
    } else {
      //设置操作后更新cookie
      const userName = getCookie(global.cookieName);
      const Authorization = getCookie('Authorization');
      const companyId = getCookie(global.companyId);
      if (userName != undefined && userName != '' && Authorization != undefined && Authorization != '' && companyId != undefined && companyId != '') {
        setCookie(global.cookieName, userName);
        setCookie('Authorization', Authorization);
        setCookie(global.companyId, companyId);
      }
      if (!getRouter) {//不加这个判断，路由会陷入死循环
        if (!getObjArr('router')) {
          api.security.userMenu("userName", getCookie(global.cookieName))
            .then(res => {
              getRouter = res.data;
              saveObjArr('router', getRouter) //存储路由到localStorage
              routerGo(to, next)//执行路由跳转方法
            })
        } else {//从localStorage拿到了路由
          getRouter = getObjArr('router')//拿到路由
          routerGo(to, next)
        }
      } else {
        const CancelToken = axios.CancelToken
        global.store.source.cancel && global.store.source.cancel()
        global.store.source = CancelToken.source()
        next()
      }
    }
  } else {
    if (!to && !to.path.includes('login')) {
      getRouter = getObjArr('router')//拿到路由
      routerGo(to, next)
    }
    next()
  }
})

function routerGo(to, next) {
  getRouter = filterAsyncRouter(getRouter) //过滤路由
  router.addRoutes(getRouter) //动态添加路由
  global.antRouter = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
  next({...to, replace: true})
}

function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));

}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      if (route.component === 'Main') {//Main组件特殊处理
        route.component = Main
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })

  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/permission.js